import { createSlider, syncSlides } from '@/utils/slider';

document.querySelectorAll('[data-property-hero-slider]').forEach((viewport) => {
    const root = viewport.closest('.property-hero__gallery');
    if (!root || viewport.querySelectorAll('[data-property-hero-slide]').length < 2) {
        return;
    }

    root.classList.add('is-ready');

    const swiper = createSlider(viewport, {
        prev: root.querySelector('[data-property-hero-prev]'),
        next: root.querySelector('[data-property-hero-next]'),
        slidesPerView: 1,
        loop: true,
    });

    const reveal = () => syncSlides(viewport.querySelectorAll('[data-property-hero-slide]'));
    swiper.on('slideChangeTransitionEnd', reveal);
    reveal();
});
